export default __webpack_public_path__ + "static/media/fish&chips-bolditalic.b2241ad4.otf";